module.exports = __webpack_public_path__ + "img/rku10-char-5.1c04af2e.png";